/* ==========================================================================
   VELIORA — Recently Viewed Products (localStorage)
   ========================================================================== */
(function () {
  'use strict';
  const STORAGE_KEY = 'veliora:recently-viewed';
  const LIMIT = 12;
  const RELATED_WAIT_MS = 900;

  function getIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (err) {
      return [];
    }
  }

  function getCurrentHandle() {
    const el = document.querySelector('[data-current-product-id]');
    return el ? el.getAttribute('data-current-product-id') : null;
  }

  function trackCurrentProduct() {
    const id = getCurrentHandle();
    if (!id) return;
    let ids = getIds().filter((i) => i !== id);
    ids.unshift(id);
    ids = ids.slice(0, LIMIT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function hideSection(container) {
    const section = container.closest('.recently-viewed');
    if (section) section.style.display = 'none';
  }

  function waitForRelatedHandles() {
    return new Promise((resolve) => {
      let settled = false;
      const finish = (handles) => {
        if (settled) return;
        settled = true;
        resolve(handles || []);
      };
      document.addEventListener('related-products:loaded', (e) => finish(e.detail && e.detail.handles), { once: true });
      setTimeout(() => finish([]), RELATED_WAIT_MS);
    });
  }

  function renderRecentlyViewed() {
    const container = document.querySelector('[data-recently-viewed-list]');
    if (!container) return;
    const currentHandle = getCurrentHandle();

    waitForRelatedHandles().then((relatedHandles) => {
      const exclude = new Set(relatedHandles);
      if (currentHandle) exclude.add(currentHandle);

      const ids = getIds()
        .filter((i) => !exclude.has(i))
        .slice(0, parseInt(container.dataset.limit || '8', 10));

      if (!ids.length) {
        hideSection(container);
        return;
      }

      Promise.all(ids.map((id) => fetch(`/products/${id}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
        .then((products) => {
          products = products.filter(Boolean);
          if (!products.length) {
            hideSection(container);
            return;
          }
          container.innerHTML = products
            .map(
              (p) => `
            <div class="product-card">
              <div class="product-card__media-wrap">
                <a href="${p.url}"><img class="product-card__img product-card__img--front" src="${p.featured_image}" alt="${p.title}" loading="lazy" width="400" height="500"></a>
              </div>
              <h3 class="product-card__title"><a href="${p.url}">${p.title}</a></h3>
              <div class="price"><span class="price__sale">${((p.price) / 100).toFixed(2)}</span></div>
            </div>`
            )
            .join('');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    trackCurrentProduct();
    renderRecentlyViewed();
  });
})();
